import script from "./CookieConsentBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=ts&setup=true"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=d4df6afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4df6afc"]])

export default __exports__